import React from "react";
import Text from "./Text";
import { ContainerTittle, LineTittle } from "./CommonStyles";

const TittleLine = ({ title, text, maxWidthLine, weight }) => {
  return (
    <ContainerTittle>
      <Text size="24px" isTittle={true} weight={weight} margin={"0"}>
        {title}
      </Text>

      <LineTittle maxWidth={maxWidthLine} />

      <Text size="15px">{text}</Text>
    </ContainerTittle>
  );
};

export default TittleLine;